<template>

    <v-container fluid>
        <v-row dense>
            <v-col cols="12" class="pb-0">

                <title-card
                    no-padding
                    :loading="loading"
                    help="edit-project-reminder-settings"
                    title="Settings">
                    <v-container fluid class="pt-2 pl-4 pr-5 pb-0">
                        <v-row dense>

                            <v-col cols="4" class="pb-0">
                                <v-select
                                    v-model="reminderHoursModel"
                                    :items="filteredReminderOptions"
                                    clearable
                                    item-text="text"
                                    item-value="value"
                                    persistent-hint
                                    label="Send remainders"
                                    placeholder="Never"
                                ></v-select>
                            </v-col>

                        </v-row>
                    </v-container>

                </title-card>

            </v-col>

            <v-col cols="12">

                <email-editor v-if="reminderHoursModel"
                              key="reminder"
                              :project="project"
                              :selected-sub-panels="selectedSubPanels"
                              @change:translations="translationsChanged"
                              template="project-reminder">
                </email-editor>
            </v-col>
        </v-row>

    </v-container>

</template>

<script>

import TitleCard from "../../../../../components/UI/TitleCard";
import {mapState, mapActions} from 'vuex';
import Json from 'vue-json-pretty';
import moment from 'moment';
import {timeDisplay} from '../../../../../components/mixins/timeDisplayMixin';
import DatePickerField from "../../../../../components/UI/DatePickerField";
import EmailEditor from "../EmailEditor";

export default {

    mixins: [timeDisplay],

    components: {
        Json,
        TitleCard,
        DatePickerField,
        EmailEditor
    },

    props: {
        project: {
            type: Object,
            required: true,
        },
        selectedSubPanels: {
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            debug: false,
            menuModel: null,
            loading: false,
            reminderOptions: [
                {text: 'in 1 hour', value: 1},
                {text: 'in 2 hours', value: 2},
                {text: 'in 4 hours', value: 4},
                {text: 'in 8 hours', value: 8},
                {text: 'in 10 hours', value: 10},
                {text: 'in 12 hours', value: 12},
                {text: 'in 16 hours', value: 16},
                {text: 'in 20 hours', value: 20},
                {text: 'in 1 day', value: 24},
                {text: 'in 2 days', value: 2 * 24},
                {text: 'in 3 days', value: 3 * 24},
                {text: 'in 4 days', value: 4 * 24},
                {text: 'in 5 days', value: 5 * 24},
                {text: 'in 6 days', value: 6 * 24},
                {text: 'in 7 days', value: 7 * 24},
                {text: 'in 8 days', value: 8 * 24},
                {text: 'in 9 days', value: 9 * 24},
                {text: 'in 10 days', value: 10 * 24},
            ],
        }
    },

    computed: {
        ...mapState('SubPanels', [
            'subPanels'
        ]),

        reminderHoursModel: {
            get() {
                return this.project.reminder_hours;
            },
            set(hours) {
                this.$emit('change:hours', {reminder_hours: hours});
            }
        },

        filteredReminderOptions() {

            const endDate = moment(this.project.end_date);

            let options = this.reminderOptions.filter(option => {
                const reminderDate = moment(this.project.start_date).add(option.value, 'hours');
                return !reminderDate.isAfter(endDate);
            });

            // Remove last item
            options.pop();

            return options;
        }
    },

    methods: {

        translationsChanged(translations) {
            this.$emit('change:translations', translations);
        }
    }
}
</script>
